import '../scss/product.measure.scss';
import { initializeMeasureInputs, changeInputValue } from '../components/measure-inputs';

initializeMeasureInputs();
changeInputValue();
